import { nanoid } from "nanoid";
import {
  addGrafanaThunk,
  dashBordDetailsQuery,
  updateGrafanaThunk,
} from "../../store/thunk/grafanaThunk";
import {
  handleAllComponentsLoader,
  handleAnnotations,
  handleComponentLoading,
  handleLoading,
  handleUpdateLoader,
  setDashboardState,
  updateChart,
} from "../../store/slices/grafanaChartsSlice";
import { notificationFail } from "../../store/slices/notificationSlice";
import moment from "moment";
import { getSubstanceThresholdsThunk } from "../../store/thunk/substanceThunk";
import { defaultDashboardData } from "./defaultData";

const substanceColors=[
  { color: '#b702d4', substance: 'temperature' },
  { color: '#008fd4', substance: 'humidity' },
  { color: '#dbf705', substance: 'alcohol' },
  { color: '#00ff1a', substance: 'pm2dot5' },
  { color: '#0000ff', substance: 'o3' },
  { color: '#ff0008', substance: 'no2' },
  { color: '#ff00e1', substance: 'co' },
  { color: '#9202f5', substance: 'so2' },
  { color: '#00bfa0', substance: 'h2s' },
  { color: '#991f17', substance: 'ch4' },
  { color: '#00ffff', substance: 'nh3' },
  { color: '#b702d4', substance: 'h2o2' },
  { color: '#008fd4', substance: 'hcho' },
  { color: '#dbf705', substance: 'cl2' },
  { color: '#00ff1a', substance: 'co2' },
  { color: '#0000ff', substance: 'pm1' },
  { color: '#ff0008', substance: 'pm4' },
  { color: '#ff00e1', substance: 'pm10' },
  { color: '#9202f5', substance: 'voc' },
  { color: '#00bfa0', substance: 'nox' },
  { color: '#991f17', substance: 'v_bio' },
  { color: '#00ffff', substance: 'v_total' },
  { color: '#b702d4', substance: 'v_bio2' },
  { color: '#008fd4', substance: 'v_total2' },
  { color: '#dbf705', substance: 'bio' },
  { color: '#00ff1a', substance: 'biop' },
  { color: '#0000ff', substance: 'tpm' },
  { color: '#ff0008', substance: 'v_bio_270_drk' },
  { color: '#ff00e1', substance: 'v_total_405_drk' },
  { color: '#9202f5', substance: 'v_bio_405_drk' },
  { color: '#00bfa0', substance: 'v_total_270_drk' },
  { color: '#991f17', substance: 'o2' },
  { color: '#00ffff', substance: 'n2' },
  { color: '#b702d4', substance: 'eto' },
  { color: '#008fd4', substance: 'v_tpm_ch1' },
  { color: '#dbf705', substance: 'v_bio_ch1' },
  { color: '#00ff1a', substance: 'v_tpm_ch2' },
  { color: '#0000ff', substance: 'v_bio_ch2' },
  { color: '#ff0008', substance: 'v_tpm_ch3' },
  { color: '#ff00e1', substance: 'v_bio_ch3' },
  { color: '#9202f5', substance: 'v_tpm_ch4' },
  { color: '#00bfa0', substance: 'v_bio_ch4' },
  { color: '#991f17', substance: 'bio_ch1' },
  { color: '#00ffff', substance: 'bio_ch2' },
  { color: '#b702d4', substance: 'bio_ch3' },
  { color: '#008fd4', substance: 'bio_ch4' },
  { color: '#dbf705', substance: 'tpm_ch1' },
  { color: '#00ff1a', substance: 'tpm_ch2' },
  { color: '#0000ff', substance: 'tpm_ch3' },
  { color: '#ff0008', substance: 'tpm_ch4' },
  { color: '#ff00e1', substance: 'pm4psd' },
  { color: '#9202f5', substance: 'pm0dot5psd' },
  { color: '#00bfa0', substance: 'tps' },
  { color: '#991f17', substance: 'pm10psd' },
  { color: '#00ffff', substance: 'pm1psd' },
  { color: '#b702d4', substance: 'pm2dot5psd' }
  ]
let DaysDifferentNo = 30
export const removeSeries = (data: any) => {
  const newArray = data.map((obj: any) => {
    // Create a copy of the object without the "series" key
    const { series, ...newObject } = obj.options;
    return { ...obj, options: newObject };
  });
  return newArray;
};

export const handleColors = (updateData: any,deviceColors:any) => {
  let data: any;
  const colors: any = [];
  if (updateData?.deviceNames?.length > 1) {
    const matchingObjects = deviceColors?.filter((obj1:any) =>
    updateData?.deviceNames?.some((obj2:any) => obj1.name === obj2)
    )
    
    matchingObjects.map((item:any)=>colors.push(item.color))
  } else {
    const matchingObjects = substanceColors.filter((obj1:any) =>
    updateData?.chartName?.some((obj2:any) => obj1.substance === obj2)
    );
    matchingObjects.map((item:any)=>colors.push(item.color))
  }

  return colors;
};

const addColors=(length:any)=>{
  const colors:any=[]
  for (let index = 1; index <= length; index++) {
    colors.push(substanceColors[index].color)
  }
  return colors
}

const handleYaxis=(updateData:any)=>{
  let axis:any={
          lines: {
            show: true,
          },
          labels: {
            formatter: function (val: any) {
              return val.toFixed(0);
            },
          },
        }
if(updateData?.yaxis?.min!=0){
axis={
  ...axis,
  min:updateData?.yaxis?.min
}
}if(updateData?.yaxis?.max!=0){
  axis={
    ...axis,
    max:updateData?.yaxis?.max
  }
}
return axis;
}

const addNewChart = (arg: any) => {
  const {
    updateData,
    initialValues,
    dataLocation,
    deviceColors
  } = arg;
 

  const ranges: any = defaultDashboardData?.data?.find(
    (item: any) => item.name[0] == updateData.chartName[0]
  )?.options?.annotations;

  let data: any = {
    id: nanoid(),
    indicators: updateData.indicators,
    name: updateData.chartName,
    title: updateData.title,
    location: dataLocation,
    deviceNames: updateData.deviceNames,
    devices: updateData.devices,
    comparison: Boolean(updateData?.deviceNames?.length > 1),
    sensorsList: updateData.sensorsList,
    options: {
      fill: {
        colors: handleColors(updateData,deviceColors),
        opacity: 1,
      },
      stroke: {
        width: 2,
        curve: "straight",
      },
      chart: {
        id: "realtime",
        type: "area",
        animations: {
          enabled: false,
          easing: "linear",
          dynamicAnimation: {
            speed: 1000,
          },
          toolbar: {
            show: true, // Hide the toolbar
          },
        },
        toolbar: {
          show: true,
        },
        zoom: {
          enabled: true,
        },
      },
      grid: {
        borderColor: "#dcdce0",
        xaxis: {
          lines: {
            show: true,
          },
        },
        yaxis: handleYaxis(updateData),
        padding: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 20,
        },
      },
      xaxis: {
        type: "datetime",
      },
      yaxis: {
        labels: {
          formatter: function (val: any) {
            return val.toFixed(0);
          },
        },
        title: {
          text: updateData.yAxis.title.text,
          rotate: -90,
          offsetX: 0,
          offsetY: 0,
          style: {
            color: undefined,
            fontSize: "12px",
            fontFamily: "Helvetica, Arial, sans-serif",
            fontWeight: 400,
            cssClass: "apexcharts-yaxis-title",
          },
        },
      },
      annotations: { yaxis: ranges?.yaxis ? ranges?.yaxis : [] },
      dataLabels: {
        enabled: false,
      },
    },
  };

  if (updateData?.type == "mixed") {
    data = { ...data, type: "mixed" };
  } else if (updateData.type !== "mixed" && updateData.type !== "panel") {
    data = { ...data, type: "normal" };
  } else if (updateData.type == "panel") {
    data = { ...data, type: "panel" };
  }
  if (updateData?.type !== initialValues?.type) {
    if (updateData.type !== "mixed" && updateData.type !== "panel") {
      data = {
        ...data,
        options: {
          ...data.options,
          chart: {
            ...data?.options.chart,
            type: updateData?.type,
          },
        },
      };
    }
  }
  if (updateData?.realTime !== initialValues?.realTime) {
    data = {
      ...data,
      realtime: updateData?.realTime,
    };
  }
  if (updateData?.curve !== initialValues?.curve) {
    data = {
      ...data,
      options: {
        ...data.options,
        stroke: {
          ...data.options.stroke,
          curve: updateData?.curve,
        },
      },
    };
  }
  if (updateData?.stroke !== initialValues?.stroke) {
    data = {
      ...data,
      options: {
        ...data.options,
        stroke: {
          width: Number(updateData?.stroke),
        },
      },
    };
  }
  if (updateData.yAxis.min !== initialValues.yAxis.min) {
    data = {
      ...data,
      options: {
        ...data.options,
        yaxis: {
          ...data.options.yaxis,
          min: updateData.yAxis.min,
        },
      },
    };
  }
  if (updateData.yAxis.max !== initialValues.yAxis.max) {
    data = {
      ...data,
      options: {
        ...data.options,
        yaxis: {
          ...data.options.yaxis,
          max: updateData.yAxis.max,
        },
      },
    };
  }
  if (updateData.yAxis.levels !== initialValues.yAxis.levels) {
    data = {
      ...data,
      options: {
        ...data.options,
        yaxis: {
          ...data.options.yaxis,
          levels: updateData.yAxis.levels,
        },
      },
    };
  }
  // return data;

  return {
    ...data,
    options: {
      ...data.options,
      colors: data?.options?.fill?.colors,
      stroke: { ...data?.options?.stroke, colors: data?.options?.fill?.colors },
    },
  };
};

const handleSeries = ({
  dispatch,
  graphData,
  typeGroupUpdate,
  data,
  layout,
  dashboardState,
}: any) => {
  const info: any = {
    ...data,
    options: { ...data.options, series: graphData },
  };
  let updatedSeries;
  let keyArr: any = Object.keys(typeGroupUpdate || {});

  updatedSeries = data.options.series;

  if (keyArr.length > 0) {
    updatedSeries = info?.options?.series?.map((item: any) => {
      const index = keyArr.indexOf(item.name);
      if (index !== -1) {
        return {
          ...item,
          type: typeGroupUpdate[keyArr[index]],
        };
      }
      return item;
    });
  } else {
    updatedSeries = [...info.options.series];
  }

  updatedSeries= updatedSeries.filter((item:any)=> item.name!='')

  dispatch(
    setDashboardState({
      ...dashboardState,
      dashboardData: {
        data: [
          ...dashboardState.dashboardData.data,
          {
            ...info,
            options: { ...info.options, series: updatedSeries },
          },
        ],
        grafanaLayout: layout,
      },
    })
  );

  dispatch(handleLoading(false));
};

export const handleAddChart = async (...props: any) => {
  const [
    updateData,
    dispatch,
    onClose,
    setChartInfo,
    chartInfo,
    chartData,
    dashboardState,
    initialValues,
    tenant,
    action,
    typeGroupUpdate,
    moment,
    dataLocation,
    userData,
    deviceColors
  ] = props;

  const timeDifference = updateData?.date.endDate - updateData?.date.startDate;
  // Calculate the number of days
  const daysDifference: any = timeDifference / (1000 * 60 * 60 * 24);
  if (!dashboardState.dashboardData?.data && chartInfo.length == 0) {
    dispatch(handleLoading(true));
    onClose();

    const series: any = [];
    const { payload } = await dispatch(
      dashBordDetailsQuery({
        location: dataLocation,
        substanceKeys: updateData.chartName,
        level: "fcl",
        fromDate: moment.utc(updateData?.date.startDate).format(
          "Y-MM-DD HH:mm:ssZ"
        ),
        toDate: moment.utc(updateData?.date.endDate).format("Y-MM-DD HH:mm:ssZ"),
        deviceKeys: updateData.devices,
        sensorIds: updateData.sensorsList,
        interval: daysDifference <= 30 ? daysDifference <= 2 ? "": "10m" :"1h"
      })
    );
    if (payload) {
      let data: any;
      let dataArr: any;

      if (updateData?.deviceNames?.length > 1) {
        data = updateData?.devices?.map((item: any) =>
          payload?.filter((substance: any) => substance.deviceId == item)
        );

        dataArr = data?.map((item: any, index: any) => {
          return updateData?.chartName[0]=='thir'? {
            name: updateData?.deviceNames[index],
            data: item.map((info: any) => [
              info.time * 1000,
              Number(info.reading1.toFixed(2)),
            ]),
          }:{
            name: updateData.deviceNames[index],
            data: item.map((info: any) => [
              info.time * 1000,
              Number(info.reading.toFixed(2)),
            ]),
          };
        });
      } else {
        data = updateData?.chartName?.map((item: any) =>
          payload?.filter((substance: any) => substance.substanceKey == item)
        );

        dataArr = data?.map((item: any, index: any) => {
          return updateData?.chartName[index]=='thir'? {
            name: updateData?.chartName[index],
            data: item.map((info: any) => [
              info.time * 1000,
              Number(info.reading1.toFixed(2)),
            ]),
          }:{
            name: updateData?.chartName[index],
            data: item.map((info: any) => [
              info.time * 1000,
              Number(info.reading.toFixed(2)),
            ]),
          } ;
        });
      }

      series.push(...dataArr);

      for (let index = 0; index < series.length; index++) {
        series[index]?.data?.sort((a: any, b: any) => a[0] - b[0]);
      }
      if (!series[0]?.data) {
        dispatch(notificationFail("No Data Found"));
        dispatch(handleLoading(false));
      } else {
        const data = addNewChart({
          updateData: updateData,
          initialValues: initialValues,
          dataLocation: dataLocation,
          deviceColors:props[14]
        });

        const layout = [{ i: data.id, x: 0, y: 0, w: 20, h: 10 }];

        if (userData.group == "admin") {
          dispatch(
            addGrafanaThunk({
              username: tenant?.tenantId,
              tenant_code: tenant?.tenantCode,
              grafana_data: JSON.stringify([
                {
                  name: "Default Dashboard",
                  id: nanoid(),
                  default: true,
                  dashboardData: {
                    data: [...chartInfo, data],
                    grafanaLayout: layout,
                  },
                },
              ]),
              tenant: tenant,
            })
          );
        } else {
          dispatch(
            addGrafanaThunk({
              username: userData?.tenantId,
              tenant_code: userData?.tenantCode,
              grafana_data: JSON.stringify({
                data: [...chartInfo, data],
                grafanaLayout: layout,
                location: dataLocation,
              }),
              tenant: {
                username: userData?.username,
                tenantId: userData?.tenantId,
                tenantCode: userData?.tenantCode,
              },
            })
          );
        }
      }
    } else {
      dispatch(notificationFail("No Data Found"));
      dispatch(handleLoading(false));
    }
  } else {
    handleCustomizeChart(...props);
  }
};

//Update Modify Charts

const modifyStroke = (updateData: any) => {
  if (updateData?.stroke != 1) {
    return Number(updateData?.stroke);
  } else {
    return 1;
  }
};

export const handleCustomizeChart = async (...props: any) => {
  const [
    updateData,
    dispatch,
    onClose,
    setChartInfo,
    chartInfo,
    chartData,
    dashboardState,
    initialValues,
    tenant,
    action,
    typeGroupUpdate,
    moment,
    dataLocation,
    deviceColors
  ] = props;
  const index = dashboardState?.dashboardData?.data?.findIndex(
    (chart: any) => chart.id === updateData.id
  );

  let result = dashboardState?.dashboardData?.data?.find(
    (chart: any) => chart.id === updateData.id
  );
  
  const series: any = [];

  const timeDifference = updateData?.date.endDate - updateData?.date.startDate;
  // Calculate the number of days
  const daysDifference: any = timeDifference / (1000 * 60 * 60 * 24);  

  if (action === "add") {
    dispatch(handleLoading(true));
    onClose();
    // const data=updateData.chartName.contains('')
    const { payload } = await dispatch(
      dashBordDetailsQuery({
        location: dataLocation,
        substanceKeys:updateData.chartName,
        level: "fcl",
        fromDate: moment.utc(updateData?.date.startDate).format(
          "Y-MM-DD HH:mm:ssZ"
        ),
        toDate: moment.utc(updateData?.date.endDate).format("Y-MM-DD HH:mm:ssZ"),
        deviceKeys: updateData.devices,
        sensorIds: updateData.sensorsList,
        interval: daysDifference <= 30 ? daysDifference <= 2 ? "": "10m" :"1h"
      })
    );

    if (payload) {
      let data: any;
      let dataArr: any;
      
      if (updateData?.deviceNames?.length > 1) {
        data = updateData?.devices?.map((item: any) =>
          payload?.filter((substance: any) => substance.deviceId == item)
        );
        
        dataArr = data?.map((item: any, index: any) => {
          return updateData?.chartName[0]=='thir'? {
            name: updateData?.deviceNames[index],
            data: item.map((info: any) => [
              info.time * 1000,
              Number(info.reading1.toFixed(2)),
            ]),
          }:{
            name: updateData.deviceNames[index],
            data: item.map((info: any) => [
              info.time * 1000,
              Number(info.reading.toFixed(2)),
            ]),
          };
        });
        
      } else {
        data = updateData?.chartName?.map((item: any) =>
          payload?.filter((substance: any) => substance.substanceKey == item)
        );
        
        dataArr = data?.map((item: any, index: any) => {
          return updateData?.chartName[index]=='thir'?{
            name: updateData?.chartName[index],
            data: item.map((info: any) => [
              info.time * 1000,
              Number(info.reading1.toFixed(2)),
            ]),
          }: {
            name: updateData?.chartName[index],
            data: item.map((info: any) => [
              info.time * 1000,
              Number(info.reading.toFixed(2)),
            ]),
          };
        });
        
      }

      series.push(...dataArr);
      
      for (let index = 0; index < series.length; index++) {
        series[index]?.data?.sort((a: any, b: any) => a[0] - b[0]);
      }

      if (!series[0]?.data) {
        dispatch(notificationFail("No Data Found"));
        dispatch(handleLoading(false));
      } else {
        const data = addNewChart({
          updateData: updateData,
          initialValues: initialValues,
          dataLocation: dataLocation,
          deviceColors:props[14]
        });

        let layout: any = dashboardState?.dashboardData?.grafanaLayout;

        if (layout?.length == 0) {
          layout = [{ i: data.id, x: 0, y: 0, w: 24, h: 13 }];
        } else {
          const maxObjects = layout.reduce((maxObjs: any, currentObj: any) => {
            if (!maxObjs.length || currentObj.y > maxObjs[0].y) {
              return [currentObj];
            } else if (currentObj.y === maxObjs[0].y) {
              return [...maxObjs, currentObj];
            }
            return maxObjs;
          }, []);

          const maxObject = maxObjects.reduce(
            (maxObj: any, currentObj: any) => {
              if (currentObj.x > maxObj.x) {
                return currentObj;
              }
              return maxObj;
            },
            layout[0]
          ); // Initialize with the first object as the initial maximum

          layout = [
            ...layout,
            {
              i: data.id,
              x:
                maxObject.x + maxObject.w + 1 >= 49
                  ? 0
                  : maxObject.x + maxObject.w + 1,
              y: maxObject.x + maxObject.w + 1 > 49 ? maxObject.y + 2 : 0,
              w: 24,
              h: 13,
            },
          ];
        }

        // const charts = removeSeries(dashboardState?.dashboardData?.data);

        const state = chartData?.grafana_data?.filter(
          (item: any) => item.id !== dashboardState.id
        );
        state.map((item: any) => {
          return {
            ...item,
            dashboardData: {
              ...item.dashboardData,
              data: removeSeries(item.dashboardData.data),
            },
          };
        });

        const response = await dispatch(
          updateGrafanaThunk({
            pk: chartData?.pk,
            username: chartData?.username,
            tenant_code: chartData?.tenant_code,
            grafana_data: JSON.stringify([
              ...state,
              {
                ...dashboardState,
                dashboardData: {
                  ...dashboardState.dashboardData,
                  data: removeSeries([
                    ...dashboardState.dashboardData.data,
                    data,
                  ]),
                  grafanaLayout: layout,
                },
              },
            ]),
            tenant: tenant,
          })
        );

        if (response?.payload?.data?.updateGrafana?.success == "true") {
          handleSeries({
            dispatch,
            graphData: series,
            typeGroupUpdate: updateData.typeGroup,
            data,
            layout,
            dashboardState: dashboardState,
          });
        }
      }
    } else {
      dispatch(notificationFail("No Data Found"));
      dispatch(handleLoading(false));
    }
  } else if (action !== "add") {
    dispatch(handleComponentLoading(result.id));
    onClose();
    if (updateData?.title !== initialValues.title) {
      result = {
        ...result,
        title: updateData.title,
      };
    }

    if (updateData?.type !== initialValues.type) {
      if (updateData.type === "mixed") {
        result = { ...result, type: "mixed" };
      } else if (updateData.type !== "mixed" && updateData.type !== "panel") {
        result = {
          ...result,
          type: "normal",
          options: {
            ...result?.options,
            chart: {
              ...result?.options?.chart,
              type: updateData.type,
            },
          },
        };
        const updatedSeries = result?.options?.series?.map(
          ({ type, ...rest }: any) => rest
        );
        result = {
          ...result,
          options: {
            ...result.options,
            series: updatedSeries,
          },
        };
      } else if (updateData.type === "panel") {
        result = { ...result, type: "panel", };
      }
    }

    if (updateData?.realTime !== initialValues.realTime) {
      result = {
        ...result,
        realTime: updateData.realTime,
      };
    }

    if (updateData?.curve !== initialValues.curve) {
      result = {
        ...result,
        options: {
          ...result?.options,
          stroke: {
            ...result?.options?.stroke,
            curve: updateData.curve,
          },
        },
      };
    }

    if (updateData.stroke !== initialValues.stroke) {
      result = {
        ...result,
        options: {
          ...result?.options,
          stroke: {
            ...result?.options?.stroke,
            width: modifyStroke(updateData),
            curve:updateData?.stroke?.curve,
          },
        },
      };
    }

    if (updateData.yAxis !== initialValues.yAxis) {
      result = {
        ...result,
        options: {
          ...result?.options,
          yaxis: {
            ...result?.options.yaxis,
            min: Number(updateData.yAxis.min),
            max: Number(updateData.yAxis.max),
            tickAmount: updateData.yAxis.tickAmount,
            title: {
              ...result?.options.yaxis.title,
              text: updateData.yAxis.title.text,
            },
          },
        },
      };
    }

    if (updateData.indicators !== initialValues.indicators) {
      result = {
        ...result,
        indicators: updateData.indicators,
      };
    }

    if (
      updateData.chartName != initialValues.chartName ||
      updateData.devices != initialValues.devices ||
      updateData.sensorsList != initialValues.sensorsList
    ) {
      
      // dispatch(handleLoading(true));
      // onClose();
      const timeDifference = updateData?.date.endDate - updateData?.date.startDate;
      // Calculate the number of days
      const daysDifference: any = timeDifference / (1000 * 60 * 60 * 24);
      const { payload } = await dispatch(
        dashBordDetailsQuery({
          location: result.location,
          substanceKeys: updateData.chartName,
          level: "fcl",
          fromDate: moment.utc(updateData?.date.startDate).format("Y-MM-DD HH:mm:ssZ"),
          toDate: moment.utc(updateData?.date.endDate).format("Y-MM-DD HH:mm:ssZ"),
          deviceKeys: updateData.devices,
          sensorIds: updateData.sensorsList,
          interval: daysDifference <= 30 ? daysDifference <= 2 ? "": "10m" :"1h"
        })
      );

      if (payload) {
        let data: any;
        let dataArr: any;

        if (updateData?.deviceNames?.length > 1) {
          data = updateData?.devices?.map((item: any) =>
            payload?.filter((substance: any) => substance.deviceId == item)
          );

          dataArr = data?.map((item: any, index: any) => {
            return {
              name: updateData.deviceNames[index],
              data: item.map((info: any) => [
                info.time * 1000,
                Number(info.reading.toFixed(2)),
              ]),
            };
          });
        } else {
          data = updateData?.chartName?.map((item: any) =>
            payload?.filter((substance: any) => substance.substanceKey == item)
          );

          dataArr = data?.map((item: any, index: any) => {
            return {
              name: updateData?.chartName[index],
              data: item.map((info: any) => [
                info.time * 1000,
                Number(info.reading.toFixed(2)),
              ]),
            };
          });
        }

        series.push(...dataArr);

        for (let index = 0; index < series?.length; index++) {
          series[index]?.data?.sort((a: any, b: any) => a[0] - b[0]);
        }
        result = {
          ...result,
          name: updateData.chartName,
          deviceNames: updateData.deviceNames,
          devices: updateData.devices,
          sensorsList: updateData.sensorsList,
          options: {
            ...result?.options,
            series: series,
          },
        };
      } else {
      }
    }

 if(JSON.stringify(updateData?.date?.startDate)!=JSON.stringify(updateData?.date?.endDate)){

      const timeDifference = updateData?.date.endDate - updateData?.date.startDate;
      // Calculate the number of days
      const daysDifference: any = timeDifference / (1000 * 60 * 60 * 24);
      const { payload } = await dispatch(
        dashBordDetailsQuery({
          location: updateData?.location,
          substanceKeys: updateData.chartName,
          level: "fcl",
          fromDate: moment.utc(updateData?.date?.startDate).format("Y-MM-DD HH:mm:ssZ"),
          toDate: moment.utc(updateData?.date?.endDate).format("Y-MM-DD HH:mm:ssZ"),
          deviceKeys: updateData.devices,
          sensorIds: updateData.sensorsList,
          interval: daysDifference <= 30 ? daysDifference <= 2 ? "": "10m" :"1h"
        })
      )
      if(payload){

        let data: any;
        let dataArr: any;
        const series: any = [];
        if (updateData?.deviceNames?.length > 1) {
          data = updateData?.devices?.map((item: any) => payload?.filter(
                (substance: any) =>
                substance.deviceId == item &&
                substance.substanceKey == updateData.chartName[0] 
                )
          );
            
          dataArr = data?.map((item: any, index: any) => {
            return {
              name: updateData.deviceNames[index],
              data: item.map((info: any) => [
                info.time * 1000,
                Number(info.reading.toFixed(2)),
              ]),
            };
          });
        } else {
          data = updateData?.chartName?.map((item: any) => payload?.filter(
                (substance: any) =>
                substance.substanceKey == item &&
                substance.deviceId == updateData.devices[0] 
                )
          );

          dataArr = data?.map((item: any, index: any) => {
            return {
              name: updateData.chartName[index],
              data: item.map((info: any) => [
                info.time * 1000,
                Number(info.reading.toFixed(2)),
              ]),
            };
          });
        }

        if (dataArr?.length > 0) {
          series.push(...dataArr);
        }

        for (let index = 0; index < series.length; index++) {
          series[index]?.data?.sort((a: any, b: any) => a[0] - b[0]);
        }

        const seriesData=series?.filter((item:any)=>item.data.length!=0)
        result={
          ...result,
          options:{
            ...result.options,
            series:seriesData
          }
        }
      }
    }

    if (
      updateData.typeGroup !== initialValues.typeGroup &&
      result.type == "mixed"
    ) {
      let keyArr: any = Object.keys(updateData.typeGroup || {});
      let updatedSeries;
      if (keyArr.length > 0) {
        updatedSeries = result?.options?.series?.map((item: any) => {
          const index = keyArr.indexOf(item.name);
          if (index !== -1) {
            return {
              ...item,
              type: updateData.typeGroup[keyArr[index]],
            };
          }
          return item;
        });
      } else {
        updatedSeries = [...result.options.series];
      }
      result = {
        ...result,
        options: {
          ...result.options,
          series: updatedSeries,
        },
      };
    }

    const updatedCharts = dashboardState?.dashboardData?.data?.map(
      (chart: any, i: number) => {
        if (i === index) {
          return { ...result };
        }
        return chart;
      }
    );

    const updatedGrafanaData = chartData.grafana_data.map((item: any) => {
      return item.id === dashboardState.id
        ? {
            ...dashboardState,
            dashboardData: {
              ...dashboardState.dashboardData,
              data: updatedCharts,
            },
          }
        : item;
    });

    const response = await dispatch(
      updateGrafanaThunk({
        pk: chartData.pk,
        username: chartData.username,
        grafana_data: JSON.stringify(
          updatedGrafanaData.map((item: any) => {
            return {
              ...item,
              dashboardData: {
                ...item.dashboardData,
                data: removeSeries(item?.dashboardData?.data),
              },
            };
          })
        ),
        tenant: tenant,
      })
    );
    if (response?.payload?.data?.updateGrafana?.success == "true") {
      dispatch(
        setDashboardState({
          ...dashboardState,
          dashboardData: {
            ...dashboardState.dashboardData,
            data: updatedCharts,
          },
        })
      );
      dispatch(
        updateChart(
          updatedGrafanaData.map((item: any) => {
            return {
              ...item,
              dashboardData: {
                ...item.dashboardData,
                data: removeSeries(item?.dashboardData?.data),
              },
            };
          })
        )
      );
    } else {
      dispatch(notificationFail("Chart info Could not be updated !"));
    }
  }
};

export const updateAllCharts = async (arg: any) => {
  const { chartData, dispatch, dashboardItem, dashboardIndex, locationItem,date } =
    arg;

  dispatch(handleLoading(false));
  let thresholds = await dispatch(
    getSubstanceThresholdsThunk({
      facilityKey: handleLocation(locationItem, dashboardItem),
    })
  );

  dispatch(handleAnnotations([...thresholds?.payload]));

  let substances: any = dashboardItem?.dashboardData?.data?.flatMap(
    (item: any) => {
      return item.name;
    }
  );

  substances = substances?.reduce(function (acc: any, curr: any) {
    if (!acc.includes(curr)) acc.push(curr);
    return acc;
  }, []);

  let devices = dashboardItem?.dashboardData?.data?.flatMap((item: any) => {
    return item.devices;
  });

  devices = devices?.reduce(function (acc: any, curr: any) {
    if (!acc.includes(curr)) acc.push(curr);
    return acc;
  }, []);

  let sensors = dashboardItem?.dashboardData?.data?.flatMap((item: any) => {
    return item.sensorsList;
  });

  sensors = sensors.reduce(function (acc: any, curr: any) {
    if (!acc.includes(curr)) acc.push(curr);
    return acc;
  }, []);
  const currentDate = new Date();

  const startDate = new Date(currentDate);
  startDate.setHours(currentDate.getHours() - 1);

  // Create the endDate with the current time
  const endDate = new Date(currentDate);
  let dateTime: any = {
    startDate,
    endDate,
  };

  if(date?.startDate){
     const startOfDay = new Date(date.startDate);
      startOfDay.setHours(0, 0, 0, 0);
    if(JSON.stringify(date.startDate)==JSON.stringify(startOfDay)){
      dateTime={
        ...dateTime,
        startDate:date.startDate,
      }
    }
  }

    const timeDifference = dateTime.endDate - dateTime.startDate;
    // Calculate the number of days
    const daysDifference: any = timeDifference / (1000 * 60 * 60 * 24);

  const { payload } = await dispatch(
    dashBordDetailsQuery({
      location: handleLocation(locationItem, dashboardItem),
      substanceKeys: substances,
      level: "fcl",
      fromDate: moment.utc(dateTime.startDate).format("Y-MM-DD HH:mm:ssZ"),
      toDate: moment.utc(dateTime.endDate).format("Y-MM-DD HH:mm:ssZ"),
      deviceKeys: devices,
      sensorIds: sensors,
      interval: daysDifference <= 30 ? daysDifference <= 2 ? "": "10m" :"1h"
    })
  );
  const {payload:tempHumData} = await dispatch(
    dashBordDetailsQuery({
      location: handleLocation(locationItem, dashboardItem),
      substanceKeys: ['temperature','humidity'],
      level: "fcl",
      fromDate: moment.utc(dateTime.startDate).format("Y-MM-DD HH:mm:ssZ"),
      toDate: moment.utc(dateTime.endDate).format("Y-MM-DD HH:mm:ssZ"),
      deviceKeys: devices,
      sensorIds: ['scd42_62'],
      interval: daysDifference <= 30 ? daysDifference <= 2 ? "": "10m" :"1h"
    })
  )
  
  if (payload && !payload?.data) {
    const updatedCharts = dashboardItem.dashboardData.data.map(
      (chartItem: any, index: any) => {
        let data: any;
        let dataArr: any;
        const series: any = [];
        if (chartItem?.deviceNames?.length > 1) {
          data = chartItem?.devices?.map((item: any) => {
            if(chartItem.name[0]=='temperature'||chartItem.name[0]=='humidity' && tempHumData.length>0){
              return  tempHumData?.filter(
                (substance: any) =>
                substance.deviceId == item &&
                substance.substanceKey == chartItem.name[0] 
                )
            }else{
            return  payload?.filter(
                (substance: any) =>
                substance.deviceId == item &&
                substance.substanceKey == chartItem.name[0] 
                )
            }
          }
          );
          
          dataArr = data?.map((item: any, index: any) => {
            return chartItem.name[0]=="thir"?{
              name: chartItem.deviceNames[index],
              data: item?.map((info: any) => [
                info.time * 1000,
                Number(info.reading1.toFixed(2)),
              ]),
            }: {
              name: chartItem.deviceNames[index],
              data: item?.map((info: any) => [
                info.time * 1000,
                Number(info.reading.toFixed(2)),
              ]),
            };
          });
        } else {
          data = chartItem?.name?.map((item: any) =>{
            if((item=='temperature'||item=='humidity') && tempHumData?.length>0){
              return  tempHumData?.filter(
                (substance: any) =>
                substance.substanceKey == item &&
                substance.deviceId == chartItem.devices[0] 
                )
            }else{
            return  payload?.filter(
                (substance: any) =>
                substance.substanceKey == item &&
                substance.deviceId == chartItem.devices[0] 
                )
            }
          }
          );
          
          dataArr = data?.map((item: any, index: any) => {
            return chartItem.name[0]=='thir'?{
              name: chartItem?.name[index],
              data: item.map((info: any) => [
                info.time * 1000,
                Number(info.reading1.toFixed(2)),
              ]),
            }: {
              name: chartItem?.name[index],
              data: item.map((info: any) => [
                info.time * 1000,
                Number(info.reading.toFixed(2)),
              ]),
            };
          });
        }

        if (dataArr?.length > 0) {
          series.push(...dataArr);
        }

        for (let index = 0; index < series.length; index++) {
          series[index]?.data?.sort((a: any, b: any) => a[0] - b[0]);
        }

        const seriesData=series?.filter((item:any)=>item.data.length!=0)

        return chartItem?.options?.colors?.length==0?{
      ...chartItem,
      options: {
        ...chartItem.options,
        fill:{
          ...chartItem.options.fill,
          colors:chartItem.devices.length>1?addColors(chartItem?.devices?.length):addColors(chartItem?.name?.length)
        },
        stroke:{
          ...chartItem.options.stroke,
          colors:chartItem.devices.length>1?addColors(chartItem?.devices?.length):addColors(chartItem?.name?.length)
        },
        colors:chartItem.devices.length>1?addColors(chartItem?.devices?.length):addColors(chartItem?.name?.length),
       series: seriesData,
      },
    }
    :{
      ...chartItem,
      options: {
        ...chartItem.options,
       series: seriesData,
      },
    };;
      }
    );
    dispatch(
      setDashboardState({
        ...dashboardItem,
        dashboardData: {
          ...dashboardItem.dashboardData,
          data: updatedCharts,
        },
      })
    );
    dispatch(handleAllComponentsLoader(false));
    return "updated";
  }
  else {
    // dispatch(notificationFail("data not found"));
    dispatch(
      setDashboardState({
        ...dashboardItem,
        dashboardData: {
          ...dashboardItem.dashboardData,
          data: dashboardItem.dashboardData.data.map((item:any)=>{
            return {
              ...item,
              options:{
                ...item.options,
                series:[]
              }
            }
          }),
        },
      })
    )
    dispatch(handleAllComponentsLoader(false));
    dispatch(handleUpdateLoader(false));
    return null;
  }
};

export const updateDashboard = async (props: any) => {

  const { dispatch, chartItem,date } = props;

  const series: any = [];
  const dateTime = { ...date };
  const timeDifference = dateTime.endDate - dateTime.startDate;    
  const daysDifference: any = timeDifference / (1000 * 60 * 60 * 24);  
  const { payload } = await dispatch(
    dashBordDetailsQuery({
      location: chartItem.location,
      substanceKeys: chartItem.name,
      level: "fcl",
      fromDate: moment.utc(dateTime.startDate).format("Y-MM-DD HH:mm:ssZ"),
      toDate: moment.utc(dateTime.endDate).format("Y-MM-DD HH:mm:ssZ"),
      deviceKeys: chartItem.devices,
      sensorIds: chartItem.sensorsList,
      interval: daysDifference <= 30 ? daysDifference <= 2 ? "": "10m" :"1h"
    })
  );

  if (payload && !payload?.data) {
    let data: any;
    let dataArr: any;

    if (chartItem?.deviceNames?.length > 1) {
      data = chartItem?.devices?.map((item: any) =>
        payload?.filter((substance: any) => substance.deviceId === item)
      );

      dataArr = data?.map((item: any, index: any) => {
        return  chartItem.name[0]=='thir'?{
          name: chartItem?.deviceNames[index],
          data: item.map((info: any) => [
            info.time * 1000,
            Number(info.reading1.toFixed(2)),
          ]),
        }:{
          name: chartItem?.deviceNames[index],
          data: item.map((info: any) => [
            info.time * 1000,
            Number(info.reading.toFixed(2)),
          ]),
        };
      });
    } else {
      data = chartItem?.name?.map((item: any) =>
        payload?.filter((substance: any) => substance.substanceKey === item)
      );

      dataArr = data?.map((item: any, index: any) => {
        return chartItem.name[0]=='thir'?{
          name: chartItem?.name[index],
          data: item.map((info: any) => [
            info.time * 1000,
            Number(info.reading1.toFixed(2)),
          ]),
        }:  {
          name: chartItem?.name[index],
          data: item.map((info: any) => [
            info.time * 1000,
            Number(info.reading.toFixed(2)),
          ]),
        };
      });
    }

    series.push(...dataArr);

    for (let index = 0; index < series.length; index++) {
      series[index]?.data?.sort((a: any, b: any) => a[0] - b[0]);
    }

    let seriesData=series?.filter((item:any)=>item.data.length!=0)
    
    return chartItem?.options?.colors?.length==0
    ?{
      ...chartItem,
      options: {
        ...chartItem.options,
        chart:{
          ...chartItem.options.chart,
          animations:{
            enabled:false
          }
        },
        fill:{
          ...chartItem.options.fill,
          colors:chartItem.devices.length>1?addColors(chartItem?.devices?.length):addColors(chartItem?.name?.length)
        },
        stroke:{
          ...chartItem.options.stroke,
          colors:chartItem.devices.length>1?addColors(chartItem?.devices?.length):addColors(chartItem?.name?.length)
        },
        colors:chartItem.devices.length>1?addColors(chartItem?.devices?.length):addColors(chartItem?.name?.length),
       series: seriesData,
      },
    }
    :{
      ...chartItem,
      options: {
        ...chartItem.options,
       series: seriesData,
       chart:{
        ...chartItem.options.chart,
        animations:{
          enabled:false
        }
       }
      },
    };
  } else {
    dispatch(handleLoading(false));
    return {
      ...chartItem,
      options: {
        ...chartItem.options,
        series:[],
      },
    }
  }
};

const handleLocation = (loc: any, dashboardItem: any) => {
  localStorage.setItem('threshold',loc ? loc : dashboardItem?.dashboardData?.data[0]?.location)
  return loc ? loc : dashboardItem?.dashboardData?.data[0]?.location;
};
export const fetchTableData = async (list: any,setTableLoading:any,configureListNew:any,dataLocation:any,dispatch:any,date:any,deviceList:any,setTableData:any,dashboardData:any) => {
    setTableLoading(true);
    let allDeviceId = configureListNew.map((val: any) =>
      val.pk.replace("D|", "")
    );
    for (let index = 0; index < list.length; index++) {
      
    }

    const timeDifference = date.endDate - date.startDate;    
    const daysDifference: any = timeDifference / (1000 * 60 * 60 * 24);

    const { payload }: any = await dispatch(
      dashBordDetailsQuery({
        location: dataLocation,
        substanceKeys: list,
        level: "fcl",
        fromDate: moment.utc(date.startDate).format("Y-MM-DD HH:mm:ssZ"),
        toDate: moment.utc(date.endDate).format("Y-MM-DD HH:mm:ssZ"),
        deviceKeys: allDeviceId,
        sensorIds: [
          "scd41_62",
          "mcp3424_6A",
          "mcp3424_6E",
          "sfa30_5D",
          "sen54_69",
          "scd42_62",
        ],
        // interval: "1h"
        interval: "10m"
      })
    );
      
    if (payload?.length > 0) {
      const data = list.map((item: any) =>
        payload?.filter((substance: any) => substance.substanceKey == item)
      );

      const dummyObj: any = {};

      list.map((item: any, index: any) => (dummyObj[item] = data[index]));

      const time = dummyObj[Object.keys(dummyObj)[0]]?.map((item: any) =>
        moment.unix(item.time).format("HH:MM a, MM/DD")
      );
      const timeData: any = dummyObj[Object.keys(dummyObj)[0]].map(
        (item: any) => item.time
      );

      const resultArray: any[] = []; // Array to store the resulting objects

      for (let index = 0; index < timeData.length; index++) {
        const x: any = {};
        list.forEach(
          (item: any) =>
            (x[item] = dummyObj[item][index]?.reading.toFixed(2)
              ? dummyObj[item][index]?.reading.toFixed(2)
              : "-")
        );
        resultArray.push(x); // Store the current object in the resultArray
      }

      const info: any = resultArray.map((item: any, index) => {
        const res = {
          ...item,
          time: time[index],
          deviceId:
            dummyObj[Object.keys(dummyObj)[0]][index]?.deviceId +
            (deviceList.data.length > 4
              ? `(${
                  deviceList?.data?.find(
                    (deviceData: any) =>
                      deviceData?.id ==
                      dummyObj[Object.keys(dummyObj)[0]][index]?.deviceId
                  )["attributes"]?.name
                }) `
              : ""),
          location: dummyObj[Object.keys(dummyObj)[0]][index]?.location,
        };
        return res;
      });
      
      setTableData(info);
      setTableLoading(false);
    } else {
      setTableData([]);
      setTableLoading(false);
    }
  };

  export const handleSeriesAverage = (allData: any,batchSize:any) => {
    const groupSize = batchSize;

    const result: any = allData?.options?.series.map((item: any) => {
      let { name, data } = item;
      const minMaxData = [];

      //display device name instead of substance name
      if(allData?.options?.series?.length === 1 && allData?.deviceNames?.length === 1){
        name = allData?.deviceNames?.[0] || "";
      }

      for (let i = 0; i < data.length; i += groupSize) {
        const group = data.slice(i, i + groupSize);

        if (group.length > 0) {
          const minValueEntry = group.reduce(
            (minEntry: any, entry: any) =>
              entry[1] < minEntry[1] ? entry : minEntry,
            group[0]
          );
          const maxValueEntry = group.reduce(
            (maxEntry: any, entry: any) =>
              entry[1] > maxEntry[1] ? entry : maxEntry,
            group[0]
          );

          minMaxData.push(minValueEntry, maxValueEntry);
        }
      }
      minMaxData.sort((a, b) => a[0] - b[0]);
      return {
        name,
        data: minMaxData,
      };
    });   
    return result;

  };